<form [id]="formId" [formGroup]="formGroup" (submit)="submit()">
  @let gap = '16px';
  @let inputMode = { inputmode: 'numeric' };

  @if (bikes().length > 0) {
    <app-discount-card-selection [formGroup]="formGroup"/>
    <app-spacer/>
    <hr>
    <kendo-label [text]="'bikes' | translate"/>
    @let col = smallWidth ? { width: 'auto' } : { width: bikes().length === 1 ? 'auto' : 'calc(50% - (' + gap + '/2))' };
    @let cols = smallWidth ? [ col ] : (bikes().length === 1 ? [ col ] :  [col, col]);
    <kendo-gridlayout [cols]="cols" [gap]="{ rows: gap, cols: gap }">
      @for (bike of bikes(); track $index; let e = $even) {
        <kendo-gridlayout-item [col]="smallWidth ? 1 : (e ? 1 : 2)" [colSpan]="smallWidth ? 1 : (bikes().length === 1 ? 2 : 1)">
          <div class="col" [ngClass]="{'chosen': bike.quantity > 0}">
            <kendo-formfield [formGroupName]="'bike-' + bike.bikeType">
              <div class="product-container">
                <div class="product-label">{{ bike.translations[lang()] }}</div>
                <kendo-numerictextbox
                  [id]="'bike-quantity-' + bike.bikeType"
                  size="medium"
                  format="##"
                  [inputAttributes]="inputMode"
                  [decimals]="0"
                  [min]="0"
                  [autoCorrect]="true"
                  [max]="bike.availability"
                  [style.min-width.px]="54"
                  (wheel)="onMouseWheel()"
                  (valueChange)="onBikeQuantityChange(bike)"
                  [formControlName]="'quantity'">
                </kendo-numerictextbox>
              </div>
            </kendo-formfield>
            @let showHeightCondition = bike.quantity > 0 && !excludedHeightInsertion.includes(bike.bikeType);
            <small [ngClass]="{'k-mb-lg': showHeightCondition}">{{ 'availability' | translate }}: {{ bike.availability }}</small>
            @if (showHeightCondition) {
              @let gap='8px';
              @let quantities = Array.from(Array(bike.quantity).keys());
              @let heightCol = smallWidth ? { width: 'auto' } : { width: quantities.length === 1 ? 'auto' : 'calc(50% - (' + gap + ' / 2))'};
              @let heightCols = smallWidth ? [ heightCol ] : (quantities.length === 1 ? [ heightCol ] : [heightCol, heightCol]);
              <kendo-gridlayout [cols]="heightCols" [gap]="{ rows: gap, cols: gap }">
              @for (n of quantities; track $index; let i = $index; let ev = $even) {
                <kendo-gridlayout-item [col]="smallWidth ? 1 : (ev ? 1 : 2)" [colSpan]="smallWidth ? 1 : (quantities.length === 1 ? 2 : 1)">
                  <div class="row" [ngStyle]="{ 'margin-left': (!smallWidth && ev) ? gap : '0' }">
                  @if (!smallWidth && ev) {
                    <span style="font-size: large">&#8627;</span>
                  }
                  <kendo-formfield [formGroupName]="'bike-' + bike.bikeType">
                      <div class="product-container">
                        <div class="product-label product-height">{{ (i + 1) + '. ' + ('height' | translate) + '*' }}</div>
                        <kendo-numerictextbox
                          class="product-input"
                          size="medium"
                          format="##"
                          [inputAttributes]="inputMode"
                          [decimals]="0"
                          [min]="0"
                          [max]="274"
                          [autoCorrect]="true"
                          [spinners]="false"
                          (wheel)="onMouseWheel()"
                          [formControlName]="'height-' + (i + 1)">
                        </kendo-numerictextbox>
                        <div class="product-label" [style.min-width.px]="36">cm</div>
                      </div>
                    </kendo-formfield>
                </div>
                </kendo-gridlayout-item>
              }
              </kendo-gridlayout>
            }
          </div>
        </kendo-gridlayout-item>
      }
    </kendo-gridlayout>
  } @else {
    <div style="display: flex; justify-content: center; width: 100%;">
      <h4>{{ 'bikesSelection.noBikesAvailable' | translate }}</h4>
    </div>
  }
  @if (extraAccInBikePage().length > 0) {
    <app-spacer/>
    <hr>
    <app-spacer/>
    <div>
      <strong>{{'bikesSelection.attention' | translate}}: </strong>
      <span>{{ 'bikesSelection.extraAccessoriesWarning' | translate }}</span>
    </div>
    <app-spacer/>
    @let pCol = smallWidth ? { width: 'auto' } : { width: extraAccInBikePage().length === 1 ? 'auto' : 'calc(50% - (' + gap + '/2))' };
    @let pCols = smallWidth ? [ pCol ] : (extraAccInBikePage().length === 1 ? [ pCol ] :  [pCol, pCol]);
    <kendo-gridlayout [cols]="pCols" [gap]="{ rows: gap, cols: gap}">
      @for (accessory of extraAccInBikePage(); track $index; let evv = $even) {
        <kendo-gridlayout-item [col]="smallWidth ? 1 : (evv ? 1 : 2)" [colSpan]="smallWidth ? 1 : (extraAccInBikePage().length === 1 ? 2 : 1)">
          <kendo-formfield [formGroupName]="'accessory-' + accessory.bikeType">
            <div class="product-container">
              <div class="product-label">{{accessory.translations[lang()]}}</div>
              <kendo-numerictextbox
                size="medium"
                format="##"
                [inputAttributes]="inputMode"
                [decimals]="0"
                [min]="0"
                [max]="accessory.availability"
                [autoCorrect]="true"
                (wheel)="onMouseWheel()"
                formControlName="quantity">
              </kendo-numerictextbox>
            </div>
          </kendo-formfield>
          <small>{{ 'availability' | translate }}: {{ accessory.availability }}</small>
        </kendo-gridlayout-item>
      }
    </kendo-gridlayout>
  }
</form>
